import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';

import { SelectDataType, SelectMode } from './EMCTrend';
import dayjs from 'dayjs';
import MessageDialog, { MessageDialogResponse } from '../../atoms/Dialog/MessageDialog';
import EMCTrendGrid from './EMCTrendGrid';
import {
  GetEMCTrendDatas,
  EMCAlarmInfoModel,
  ConvertDateToStringByString,
  ConvertDateToStringByDate,
  ConvertDateToStringByMarume,
  GetAlaramBasePoint,
} from './EMCTrend';
import EMCTrendSelectItem from './EMCTrendSelectItem';
import { useModal } from '../../../function/useModal';
import EMCTrendChart from './EMCTrendChart';
import { TableBaseStyle, EMCTrendStyle } from './EMCTrendStyle';

type EMCTrendPageProps = { selectData: SelectDataType };
const EMCTrendPage: React.FC<EMCTrendPageProps> = (Props) => {
  const { t } = useTranslation();
  const emcTrendStyle = EMCTrendStyle();

  const [selectData, setSelectData] = useState<SelectDataType>({
    devIndex: '0',
    alramDate: '',
    selectDate: ConvertDateToStringByMarume(new Date()),
    selectMode: SelectMode.DAY_MODE,
  });

  const [emcAlarmInfoModel, setEMCAlarmInfoModel] = useState<EMCAlarmInfoModel[]>([]);

  const [buttonEnable, setButtonEnable] = useState<boolean>(false);
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();

  const [dlgmsg, setDlgmsg] = useState<string>('');

  const [chartSelectData, setChartSelectData] = useState<string>('');

  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  const allSelectCheckBox = React.useRef<boolean>(true); //表示非表示のチェックボックス状態

  //データ選択基準日時設定（アラーム選択モードの時グラフに線を引く）
  const chartAlramBasePointData = React.useRef<string>('');

  /**
   * 初期表示　useEffect
   */
  useEffect(() => {}, []);

  /**
   * 表示ボタンアクション
   */
  const dispAction = (target: SelectDataType) => {
    setButtonEnable(false);
    GetEMCTrendDatas(target)
      .then((r) => {
        setEMCAlarmInfoModel([...r]);
        setChartSelectData('');
        setSelectData({ ...target });

        let alramDate = target.alramDate;
        if (target.selectMode === SelectMode.ALRAM_MODE && r.length !== 0) {
          alramDate = GetAlaramBasePoint(r[0], target.alramDate);
        }
        chartAlramBasePointData.current = target.selectMode === SelectMode.DAY_MODE ? '' : alramDate;
        console.debug(['dispAction - chartAlramBasePointData', chartAlramBasePointData.current]);
      })
      .catch((e) => {
        setDlgmsg(t('EMCTrendPage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
        console.error(['dispAction error', e]);
      })
      .finally(() => {
        setButtonEnable(true);
      });
  };

  /**
   *　グラフデータ選択処理
   */
  const chartControlClikAction = (target: string) => {
    setChartSelectData(target);
  };

  /**
   * グラフ線表示非表示切替アクション
   * @param indexNo
   */
  const lineDispFlgChangeAction = (itemNo: string) => {
    var index = emcAlarmInfoModel.findIndex((r) => r.ItemNo === itemNo);
    if (index !== -1) {
      emcAlarmInfoModel[index].IsDisplay = !emcAlarmInfoModel[index].IsDisplay;
      setEMCAlarmInfoModel([...emcAlarmInfoModel]);
    }
  };
  /**
   * グラフ線All非表示切替アクション
   * @param indexNo
   */
  const lineDispFlgAllOffAction = () => {
    if (allSelectCheckBox.current) {
      emcAlarmInfoModel.forEach((r) => (r.IsDisplay = false));
    } else {
      emcAlarmInfoModel.forEach((r) => (r.IsDisplay = true));
    }
    allSelectCheckBox.current = !allSelectCheckBox.current;
    setEMCAlarmInfoModel([...emcAlarmInfoModel]);
  };

  return (
    <>
      <Grid
        container
        justify="flex-start"
        spacing={1}
        direction="row"
        alignItems="center"
        classes={{ 'spacing-xs-1': emcTrendStyle.spacingXs1 }}
      >
        <Grid item xs={12}>
          <EMCTrendSelectItem buttonEnable={buttonEnable} onClickDispButton={(r) => dispAction(r)}></EMCTrendSelectItem>
        </Grid>
        <Grid item xs={9}>
          <EMCTrendChart
            emcAlarmInfoModel={emcAlarmInfoModel}
            onChartSelectDataChangeEvent={chartControlClikAction}
            chartSelectData={chartSelectData}
            chartAlramBasePointData={chartAlramBasePointData.current}
          ></EMCTrendChart>
        </Grid>
        <Grid item xs={3}>
          {emcAlarmInfoModel.length === 0 ? null : (
            <EMCTrendGrid
              emcAlarmInfoModel={emcAlarmInfoModel}
              chartSelectData={chartSelectData}
              onLineDispCkeckBoxChange={lineDispFlgChangeAction}
              onLineDispAllOff={lineDispFlgAllOffAction}
            ></EMCTrendGrid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default EMCTrendPage;
